import React, { useState, useContext, useEffect } from 'react'
import styled from 'styled-components'
import { AuthContext } from '../../../../../auth-context'
import moment from 'moment'
import CircularProgress from '@material-ui/core/CircularProgress'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import { measurementMap } from './measurement-modal'
import FatLoss from '../../../../../images/change-goal-pictures/weight-loss-2020.png'
import Maintenance from '../../../../../images/change-goal-pictures/maintenance-2020.png'
import MuscleGain from '../../../../../images/change-goal-pictures/muscle-gain-2020.png'
import ReverseDieting from '../../../../../images/change-goal-pictures/reverse-2020.png'
import HighArrow from '../../../../../images/highArrow.png'
import LowArrow from '../../../../../images/lowArrow.png'
import LeftRightArrow from '../../../../../images/leftRightArrow.png'
import { ReactComponent as Measure } from '../../../../../images/measure.svg'
import { ReactComponent as Caliper } from '../../../../../images/caliper.svg'
import { ReactComponent as BodyFatSymbol } from '../../../../../images/gis_measure.svg'
import { getPortalAccountWeighInPhotos } from '../../../../../api'

const GoalIconSrc = {
  'FAT LOSS': FatLoss,
  'MUSCLE GAIN': MuscleGain,
  'REVERSE DIETING': ReverseDieting,
  'MAINTENANCE': Maintenance,
}

const Title = styled.h2`
  margin: 20px 0px;
`

const ImagesWrapper = styled.div`
  width: 552px;
  height: 244px;
`

const ImageWrapper = styled.div`
  display: inline-block;
  margin: 2px;
  padding: 4px;
  width: 180px;
  height: 240px;
`

const ImageWrapperSelected = styled.div`
  display: inline-block;
  margin: 2px;
  padding: 2px;
  border: 2px solid green;
  width: 180px;
  height: 240px;
`

const ProgressPhotoImage = styled.img`
  margin: 0 !important;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`

const OthersWrapper = styled.div`
  height: 408px;
  overflow-y: auto;
  background-color: #f8f9fb;
`

const OthersRowWrapper = styled.div`
  width: 552px;
  height: 47px;
  margin: 4px 0;
  padding: 4px;
  border-radius: 16px;
  cursor: pointer;
`

const OthersRowDate = styled.div`
  display: inline-block;
  width: 180px;
  text-align: center;
`

const OthersRowGoalIconWrapper = styled.div`
  display: inline-block;
  width: 47px;
  height: 39px;
  padding: 0 4px;
`

const OthersRowGoalIconImage = styled.img`
  margin: 0 !important;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  vertical-align: middle;
`

const OthersRowWeight = styled.div`
  display: inline-block;
  width: 170px;
  text-align: center;
`

const OthersRowThumbnailWrapper = styled.div`
  display: inline-block;
  width: 47px;
  height: 39px;
  padding: 0 4px;
`

const OthersRowThumbnailImage = styled.img`
  margin: 0 !important;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  vertical-align: middle;
`

const ComparisonWrapper = styled.div`
  width: 552px;
  height: 652px;
`

const ComparisonImageWrapper = styled.div`
  display: inline-block;
  padding: 2px;
  width: 276px;
  height: 368px;
`

const MeasurementsWrapper = styled.div`
  width: 552px;
  height: 249px;
  position: relative;
  border-radius: 16px 16px 0 0;
  overflow-y: auto;
`

export const PhotoModal = ({open, onClose, record, loading, photos, accountId, account}) => {
  const timeline = account.timeline
  const { user } = useContext(AuthContext)
  const [selected, setSelected] = useState(0)
  const [scrollTop, setScrollTop] = useState(0)
  const [comparison, setComparison] = useState(null)
  const [comparisonLoading, setComparisonLoading] = useState(false)
  const [comparisonPhotos, setComparisonPhotos] = useState({})

  useEffect(() => {
    if (open && record !== null && !comparisonLoading) {
      let idToLoad = null
      if (comparison !== null) {
        if (!(comparison.id.toString() in comparisonPhotos)) {
          idToLoad = comparison.id
        }
      } else {
        const r = scrollTop % 51
        const q = (scrollTop - r) / 51
        const s = q + 5 + (r ? 1 : 0)
        let j = 0
        for (let m = timeline.length - 1; m >= 0; --m) {
          const x = timeline[m]
          if (x.id !== record.id && x.photo_option === 3 && x.report_date >= account.user.starting_point) {
            if (j >= s) {
              break
            } else if (j >= q) {
              if (!(x.id.toString() in comparisonPhotos)) {
                idToLoad = x.id
                break
              }
            }
            ++j
          }
        }
      }
      if (idToLoad !== null) {
        setComparisonLoading(true)
        getPortalAccountWeighInPhotos(user.id, accountId, idToLoad).then((res) => {
          let newComparisonPhotos = Object.assign({}, comparisonPhotos)
          newComparisonPhotos[idToLoad.toString()] = res.data.photos
          setComparisonPhotos(newComparisonPhotos)
          setComparisonLoading(false)
        })
      }
    }
  }, [open, record, accountId, account, timeline, user.id, selected, scrollTop, comparison, comparisonLoading, comparisonPhotos])

  const handleComparison = (item) => {
    setComparison(item)
  }

  const handleBack = () => {
    setScrollTop(0)
    setComparison(null)
  }

  const handleScroll = (e) => {
    setScrollTop(e.target.scrollTop)
  }

  const handleClose = () => {
    setSelected(0)
    setScrollTop(0)
    setComparison(null)
    setComparisonPhotos({})
    onClose()
  }

  const renderOthersRowWrapper = (item, index) => {
    let thumbnailAvailable = [null, null, null]
    const itemIdStr = item.id.toString()
    if (itemIdStr in comparisonPhotos) {
      const photoList = JSON.parse(record.photo_list)
      const comparisonPhotoList = JSON.parse(item.photo_list)
      for (let m = 0; m < photoList.length; ++m) {
        for (let n = 0; n < comparisonPhotoList.length; ++n) {
          if (comparisonPhotoList[n][0] === photoList[m][0]) {
            thumbnailAvailable[m] = n
            break
          }
        }
      }
    }
    return (
      <OthersRowWrapper key={index} onClick={() => handleComparison(item)} style={{backgroundColor: item.check_in_type === 1 ? '#fff0f0' : '#f0fff0'}}>
        <OthersRowDate>{moment.utc(item.report_date).format('MMM D, YYYY')}</OthersRowDate>
        <OthersRowGoalIconWrapper><OthersRowGoalIconImage src={GoalIconSrc[item.goal]} /></OthersRowGoalIconWrapper>
        <OthersRowWeight>{((item.estimated_weight !== null ? item.estimated_weight : item.weight) * 2.204622).toFixed(1)} lbs</OthersRowWeight>
        {thumbnailAvailable[0] !== null && (<OthersRowThumbnailWrapper><OthersRowThumbnailImage src={comparisonPhotos[itemIdStr][thumbnailAvailable[0]][1]} /></OthersRowThumbnailWrapper>)}
        {thumbnailAvailable[1] !== null && (<OthersRowThumbnailWrapper><OthersRowThumbnailImage src={comparisonPhotos[itemIdStr][thumbnailAvailable[1]][1]} /></OthersRowThumbnailWrapper>)}
        {thumbnailAvailable[2] !== null && (<OthersRowThumbnailWrapper><OthersRowThumbnailImage src={comparisonPhotos[itemIdStr][thumbnailAvailable[2]][1]} /></OthersRowThumbnailWrapper>)}
      </OthersRowWrapper>
    )
  }

  const renderMeasurementRow = (measurement, index) => {
    const code = measurement[0]
    const leftRaw = measurement[1]
    const rightRaw = measurement[2]
    let leftValue
    let rightValue
    let diffValue
    let leftValueStr
    let rightValueStr
    let diffValueStr
    let result

    if (code === 'weight' || code === 'lean_body_mass') {
      leftValue = Math.round(leftRaw * 2.204622 * 10) / 10
      rightValue = Math.round(rightRaw * 2.204622 * 10) / 10
      diffValue = rightValue - leftValue
      leftValueStr = leftValue.toFixed(1)
      rightValueStr = rightValue.toFixed(1)
      diffValueStr = diffValue === 0 ? 'same' : Math.abs(diffValue).toFixed(1)
      result = (
        <div key={index} style={{height: '29px', backgroundColor: '#f8f8f8'}}>
          <div style={{display: 'inline-block', width: '24px'}}><img width={22} src={code === 'weight' ? FatLoss : MuscleGain} alt="symbol" style={{verticalAlign: 'middle', marginBottom: '0'}} /></div>
          <div style={{display: 'inline-block', width: '157px', paddingLeft: '10px'}}>{code === 'weight' ? 'Weight' : 'Lean body mass'}</div>
          <div style={{display: 'inline-block', width: '88px', textAlign: 'right', paddingLeft: '15px'}}>{leftValueStr}{leftValue === null ? '' : ' lbs'}</div>
          <div style={{display: 'inline-block', width: '88px', textAlign: 'right', paddingLeft: '15px'}}>{rightValueStr}{rightValue === null ? '' : ' lbs'}</div>
          <div style={{display: 'inline-block', width: '76px', textAlign: 'right', paddingLeft: '15px'}}>{diffValueStr}{diffValue === null || diffValue === 0 ? '' : ' lbs'}</div>
          <div style={{display: 'inline-block', width: '26px', paddingLeft: '5px', textAlign: 'center'}}>{diffValue === null ? '' : (<img width={diffValue === 0 ? 21 : 10} height={14} src={(diffValue < 0) ? LowArrow : (diffValue > 0 ? HighArrow : LeftRightArrow)} alt="arrow" style={{verticalAlign: 'middle', marginBottom: '0'}} />)}</div>
        </div>
      )
    } else if (code === 'body_fat') {
      leftValue = leftRaw
      rightValue = rightRaw
      diffValue = rightValue - leftValue
      leftValueStr = leftRaw.toFixed(1) + '%'
      rightValueStr = rightValue.toFixed(1) + '%'
      diffValueStr = diffValue === 0 ? 'same' : (Math.abs(diffValue).toFixed(1) + '%')
      result = (
        <div key={index} style={{height: '29px', backgroundColor: '#f8f8f8'}}>
          <div style={{display: 'inline-block', width: '24px'}}><BodyFatSymbol style={{verticalAlign: 'middle'}} /></div>
          <div style={{display: 'inline-block', width: '157px', paddingLeft: '10px'}}>Body fat</div>
          <div style={{display: 'inline-block', width: '88px', textAlign: 'right', paddingLeft: '15px'}}>{leftValueStr}</div>
          <div style={{display: 'inline-block', width: '88px', textAlign: 'right', paddingLeft: '15px'}}>{rightValueStr}</div>
          <div style={{display: 'inline-block', width: '76px', textAlign: 'right', paddingLeft: '15px'}}>{diffValueStr}</div>
          <div style={{display: 'inline-block', width: '26px', paddingLeft: '5px', textAlign: 'center'}}>{diffValue === null ? '' : (<img width={diffValue === 0 ? 21 : 10} height={14} src={(diffValue < 0) ? LowArrow : (diffValue > 0 ? HighArrow : LeftRightArrow)} alt="arrow" style={{verticalAlign: 'middle', marginBottom: '0'}} />)}</div>
        </div>
      )
    } else if (code.endsWith('_skinfold')) {
      leftValue = leftRaw
      rightValue = rightRaw
      diffValue = (leftValue === null || rightValue === null) ? null : (rightValue - leftValue)
      leftValueStr = leftValue === null ? '-' : leftValue.toFixed(0)
      rightValueStr = rightValue === null ? '-' : rightValue.toFixed(0)
      diffValueStr = diffValue === null ? '-' : (diffValue === 0 ? 'same' : Math.abs(diffValue).toFixed(0))
      result = (
        <div key={index} style={{height: '29px', backgroundColor: '#f8f8f8'}}>
          <div style={{display: 'inline-block', width: '24px'}}><Caliper style={{verticalAlign: 'middle'}} /></div>
          <div style={{display: 'inline-block', width: '157px', paddingLeft: '10px'}}>{measurementMap[code]}</div>
          <div style={{display: 'inline-block', width: '88px', textAlign: 'right', paddingLeft: '15px'}}>{leftValueStr}{leftValue === null ? '' : ' mm'}</div>
          <div style={{display: 'inline-block', width: '88px', textAlign: 'right', paddingLeft: '15px'}}>{rightValueStr}{rightValue === null ? '' : ' mm'}</div>
          <div style={{display: 'inline-block', width: '76px', textAlign: 'right', paddingLeft: '15px'}}>{diffValueStr}{diffValue === null || diffValue === 0 ? '' : ' mm'}</div>
          <div style={{display: 'inline-block', width: '26px', paddingLeft: '5px', textAlign: 'center'}}>{diffValue === null ? '' : (<img width={diffValue === 0 ? 21 : 10} height={14} src={(diffValue < 0) ? LowArrow : (diffValue > 0 ? HighArrow : LeftRightArrow)} alt="arrow" style={{verticalAlign: 'middle', marginBottom: '0'}} />)}</div>
        </div>
      )
    } else {
      leftValue = leftRaw === null ? null : Math.round(leftRaw / 2.54)
      rightValue = rightRaw === null ? null : Math.round(rightRaw / 2.54)
      diffValue = (leftValue === null || rightValue === null) ? null : (rightValue - leftValue)
      leftValueStr = leftValue === null ? '-' : leftValue.toFixed(0)
      rightValueStr = rightValue === null ? '-' : rightValue.toFixed(0)
      diffValueStr = diffValue === null ? '-' : (diffValue === 0 ? 'same' : Math.abs(diffValue).toFixed(0))
      result = (
        <div key={index} style={{height: '29px', backgroundColor: '#f8f8f8'}}>
          <div style={{display: 'inline-block', width: '24px'}}><Measure style={{verticalAlign: 'middle'}} /></div>
          <div style={{display: 'inline-block', width: '157px', paddingLeft: '10px'}}>{measurementMap[code]}</div>
          <div style={{display: 'inline-block', width: '88px', textAlign: 'right', paddingLeft: '15px'}}>{leftValueStr}{leftValue === null ? '' : ' in'}</div>
          <div style={{display: 'inline-block', width: '88px', textAlign: 'right', paddingLeft: '15px'}}>{rightValueStr}{rightValue === null ? '' : ' in'}</div>
          <div style={{display: 'inline-block', width: '76px', textAlign: 'right', paddingLeft: '15px'}}>{diffValueStr}{diffValue === null || diffValue === 0 ? '' : ' in'}</div>
          <div style={{display: 'inline-block', width: '26px', paddingLeft: '5px', textAlign: 'center'}}>{diffValue === null ? '' : (<img width={diffValue === 0 ? 21 : 10} height={14} src={(diffValue < 0) ? LowArrow : (diffValue > 0 ? HighArrow : LeftRightArrow)} alt="arrow" style={{verticalAlign: 'middle', marginBottom: '0'}} />)}</div>
        </div>
      )
    }
    return result
  }

  let comparisonSelected = 0
  let measurements = []
  if (record !== null && !loading && timeline !== null && comparison !== null) {
    const photoList = JSON.parse(record.photo_list)
    const comparisonPhotoList = JSON.parse(comparison.photo_list)
    for (let n = 0; n < comparisonPhotoList.length; ++n) {
      if (comparisonPhotoList[n][0] === photoList[selected][0]) {
        comparisonSelected = n
        break
      }
    }
    let measurementsObj = {}
    if (record.measurements !== null) {
      for (let m in record.measurements.data) {
        measurementsObj[m] = [Number(record.measurements.data[m]), null]
      }
    }
    if (comparison.measurements !== null) {
      for (let m in comparison.measurements.data) {
        if (m in measurementsObj) {
          measurementsObj[m] = [measurementsObj[m][0], Number(comparison.measurements.data[m])]
        } else {
          measurementsObj[m] = [null, Number(comparison.measurements.data[m])]
        }
      }
    }
    measurements.push(['weight', record.weight, comparison.weight])
    measurements.push(['body_fat', record.body_fat, comparison.body_fat])
    measurements.push(['lean_body_mass', record.weight * (1 - record.body_fat / 100), comparison.weight * (1 - comparison.body_fat / 100)])
    for (let m in measurementMap) {
      if (m in measurementsObj) {
        measurements.push([m, measurementsObj[m][0], measurementsObj[m][1]])
      }
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
    >
      <DialogContent className="avn-modal-content-container">
        {(record === null || loading || timeline === null) ? (
          <CircularProgress size={32} />
        ) : (comparison === null ? (
          <>
            <Title>Photos for {moment.utc(record.report_date).format('MMM D, YYYY')} check-in</Title>
            <ImagesWrapper>
              {photos.map((item, index) => index === selected ? (
                <ImageWrapperSelected key={index}>
                  <ProgressPhotoImage src={item[0]} />
                </ImageWrapperSelected>
              ) : (
                <ImageWrapper key={index} onClick={() => setSelected(index)}>
                  <ProgressPhotoImage src={item[0]} />
                </ImageWrapper>
              ))}
            </ImagesWrapper>
            <p>Compare with ...</p>
            <OthersWrapper onScroll={handleScroll}>
              {timeline.slice(0).reverse().map((item, index) => item.id !== record.id && item.photo_option === 3 && item.report_date >= account.user.starting_point && renderOthersRowWrapper(item, index))}
            </OthersWrapper>
          </>
        ) : (
          <>
            <Title>{moment.utc(record.report_date).format('MMM D, YYYY')} compared to {moment.utc(comparison.report_date).format('MMM D, YYYY')}</Title>
            <ComparisonWrapper>
              {comparisonLoading ? (
                <CircularProgress size={32} />
              ) : (
                <>
                  <ComparisonImageWrapper>
                    <ProgressPhotoImage src={photos[selected][0]} />
                  </ComparisonImageWrapper>
                  <ComparisonImageWrapper>
                    {(comparison.id.toString() in comparisonPhotos) && comparisonPhotos[comparison.id.toString()][comparisonSelected] && (
                      <ProgressPhotoImage src={comparisonPhotos[comparison.id.toString()][comparisonSelected][0]} />
                    )}
                  </ComparisonImageWrapper>
                  <MeasurementsWrapper>
                    <div style={{position: 'sticky', top: '0', left: '0', height: '48px', paddingTop: '13px', fontWeight: 'bold', color: '#fff', background: 'linear-gradient(#070d2c 30%,#06010d)'}}>
                      <div style={{display: 'inline-block', width: '24px'}}></div>
                      <div style={{display: 'inline-block', width: '157px', textAlign: 'left', paddingLeft: '10px'}}>Measurement</div>
                      <div style={{display: 'inline-block', width: '88px', textAlign: 'right', paddingLeft: '15px'}}>{moment.utc(record.report_date).format('M/D/YY')}</div>
                      <div style={{display: 'inline-block', width: '88px', textAlign: 'right', paddingLeft: '15px'}}>{moment.utc(comparison.report_date).format('M/D/YY')}</div>
                      <div style={{display: 'inline-block', width: '91px', textAlign: 'right', paddingLeft: '15px'}}>change</div>
                    </div>
                    {measurements.map(renderMeasurementRow)}
                  </MeasurementsWrapper>
                </>
              )}
            </ComparisonWrapper>
            <p style={{cursor: 'pointer'}} onClick={handleBack}>Return to list</p>
          </>
        ))}
      </DialogContent>
      <DialogActions className='avn-modal-actions-container'>
        <button className="avn-modal-action" onClick={handleClose}>Close</button>
      </DialogActions>
    </Dialog>
  )
}